module.exports = __webpack_public_path__ + "img/copy.fa750698.svg";